import { pushCellHistory } from "../pushCellHistory";
import { snapCells } from "../snapCells";
import { sortCells } from "../sortCells";
import { CELL_THRESHOLD, State } from "../types";

export type SplitCellAction = Readonly<{
  direction: "row" | "col";
  type: "SPLIT CELL";
}>;

export const splitCell = (state: State, action: SplitCellAction): State => {
  const { mousePosition, withinGutter } = state;
  if (mousePosition === null || withinGutter !== null) {
    return state;
  }
  const cellSplitIndex = state.cells.findIndex(
    cell =>
      mousePosition[0] >= cell.minX &&
      mousePosition[0] <= cell.maxX &&
      mousePosition[1] >= cell.minY &&
      mousePosition[1] <= cell.maxY,
  );
  if (cellSplitIndex < 0) {
    return state;
  }
  const cellToSplit = state.cells[cellSplitIndex];
  let newCells: State["cells"];
  switch (action.direction) {
    case "col": {
      newCells = [
        {
          ...cellToSplit,
          minX: mousePosition[0],
          selected:false
        },
        {
          ...cellToSplit,
          maxX: mousePosition[0],
        },
      ];
      break;
    }
    case "row":
      newCells = [
        {
          ...cellToSplit,
          minY: mousePosition[1],
          selected:false
        },
        {
          ...cellToSplit,
          maxY: mousePosition[1],
        },
      ];
      break;
  }

  const cells = [
    ...state.cells.slice(0, cellSplitIndex),
    ...newCells,
    ...state.cells.slice(cellSplitIndex + 1),
  ];

  return pushCellHistory(
    state,
    sortCells(snapCells(cells, state.zoneWidth, state.zoneHeight, CELL_THRESHOLD)),
    {
      mouseDragStart: null,
      mousePosition: null,
      showTableUI: true,
    },
  );
};
